"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _Record2;

var SubscriptionEmail =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(SubscriptionEmail, _Record);

  function SubscriptionEmail() {
    (0, _classCallCheck2.default)(this, SubscriptionEmail);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubscriptionEmail).apply(this, arguments));
  }

  (0, _createClass2.default)(SubscriptionEmail, [{
    key: "getId",
    value: function getId() {
      return this[_constants.ID];
    }
  }, {
    key: "getIsPublished",
    value: function getIsPublished() {
      return this[_constants.SUBSCRIPTION_EMAIL_STATUS] === _constants.SUBSCRIPTION_EMAIL_STATUSES.PUBLISHED;
    }
  }, {
    key: "getIsDragDrop",
    value: function getIsDragDrop() {
      return this[_constants.EMAIL_TEMPLATE_TYPE] === _constants.EMAIL_TEMPLATE_TYPES.DRAG_AND_DROP;
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new SubscriptionEmail(json);
    }
  }]);
  return SubscriptionEmail;
}((0, _immutable.Record)((_Record2 = {}, (0, _defineProperty2.default)(_Record2, _constants.ID, false), (0, _defineProperty2.default)(_Record2, _constants.EMAIL_TEMPLATE_TYPE, null), (0, _defineProperty2.default)(_Record2, _constants.SUBSCRIPTION_EMAIL_STATUS, null), _Record2)));

var _default = SubscriptionEmail;
exports.default = _default;
module.exports = exports.default;